<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M1 6C1 5.44772 1.44772 5 2 5L10 5C10.5523 5 11 5.44772 11 6C11 6.55228 10.5523 7 10 7L2 7C1.44771 7 1 6.55228 1 6Z"
		fill="currentColor"
	/>
</svg>
